import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Icon,
  Link,
  Box,
} from "@chakra-ui/react";
import { FaImage, FaFileAudio, FaExternalLinkAlt } from "react-icons/fa";

const DoctorOpinionModal = ({ isOpen, onClose, opinionData }) => {
  if (!opinionData) return null;

  const renderContent = () => {
    switch (opinionData.mime_type) {
      case "Image":
        return (
          <VStack align="stretch" spacing={4}>
            {(Array.isArray(opinionData.opinion)
              ? opinionData.opinion
              : [opinionData.opinion]
            ).map((url, index) => (
              <HStack
                key={index}
                justify="space-between"
                p={2}
                bg="gray.50"
                borderRadius="md"
              >
                <HStack>
                  <Icon as={FaImage} color="blue.500" />
                  <Text>Image {index + 1}</Text>
                </HStack>
                <Link href={url} isExternal>
                  <Icon as={FaExternalLinkAlt} />
                </Link>
              </HStack>
            ))}
          </VStack>
        );

      case "Audio":
        return (
          <VStack align="stretch" spacing={4}>
            {(Array.isArray(opinionData.opinion)
              ? opinionData.opinion
              : [opinionData.opinion]
            ).map((url, index) => (
              <Box key={index} p={4} bg="gray.50" borderRadius="md">
                <HStack justify="space-between" mb={4}>
                  <HStack>
                    <Icon as={FaFileAudio} color="blue.500" />
                    <Text>Audio File {index + 1}</Text>
                  </HStack>
                  <Link href={url} isExternal download>
                    <Icon as={FaExternalLinkAlt} />
                  </Link>
                </HStack>
                <audio
                  controls
                  preload="metadata"
                  style={{ width: "100%" }}
                  controlsList="nodownload"
                >
                  <source src={url} type="audio/mp3" />
                  <source src={url} type="audio/mpeg" />
                  <source src={url} type="audio/wav" />
                  <source src={url} type="audio/m4a" />
                  Your browser does not support the audio element.
                </audio>
              </Box>
            ))}
          </VStack>
        );

      case "Text":
        return (
          <Box p={4} bg="gray.50" borderRadius="md">
            <Text>
              {Array.isArray(opinionData.opinion)
                ? opinionData.opinion[0]
                : opinionData.opinion}
            </Text>
          </Box>
        );

      default:
        return <Text>Unsupported content type</Text>;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          {opinionData.type}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>{renderContent()}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DoctorOpinionModal;
